import { get, set } from 'lodash'
import type { EditorSDK, UnproxiedEditorSDK } from '../types'
import { bindObjectFunctions } from './bindObjectFunctions'

const unwrappedFunctionNames = [
  'editor.updateAppState',
  'info.getEntityIdFromRef',
  'addEventListener',
  'editor.routers.addVariantToPage',
  'editor.routers.getVariantPageRule',
  'editor.routers.updateVariantPageRule',
]

export const createEditorSdkProxy = (
  editorSDK: UnproxiedEditorSDK,
  token: string,
): EditorSDK => {
  const originalFunctions = {}
  unwrappedFunctionNames.forEach(functionName => {
    // @ts-expect-error typing
    originalFunctions[functionName] = get(editorSDK, functionName)
  })

  const wrappedSdk = bindObjectFunctions(editorSDK, token)

  unwrappedFunctionNames.forEach(functionName => {
    // @ts-expect-error typing
    set(wrappedSdk, functionName, originalFunctions[functionName])
  })

  return wrappedSdk
}
